var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 84,
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 5.25C59.33 5.25 75 21.7035 75 42C75 62.2965 59.33 78.75 40 78.75C20.67 78.75 5 62.2965 5 42C5 21.7035 20.67 5.25 40 5.25Z",
    fill: "#E74C3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7726 58.9756C33.7726 58.9756 31.9602 60.1427 35.0639 60.5365C38.8246 61.0115 40.7463 60.9431 44.8893 60.0767C44.8893 60.0767 45.9808 60.8321 47.5024 61.4863C38.2117 65.8898 26.4758 61.2311 33.7723 58.9756L33.7726 58.9756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6365 53.2283C32.6365 53.2283 30.6034 54.8936 33.7094 55.2487C37.7271 55.7076 40.8986 55.7452 46.3896 54.5761C46.3896 54.5761 47.1474 55.4276 48.3407 55.8929C37.1094 59.5273 24.6006 56.1789 32.6359 53.2283L32.6365 53.2283Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.206 43.4767C44.4964 46.3935 41.6054 49.0161 41.6054 49.0161C41.6054 49.0161 47.4177 45.6972 44.7489 41.5392C42.2555 37.6634 40.3439 35.738 50.6931 29.0978C50.6932 29.0978 34.4471 33.5855 42.206 43.4765L42.206 43.4767Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4937 63.227C54.4937 63.227 55.8354 64.4506 53.0159 65.3969C47.6546 67.1934 30.6972 67.7354 25.9872 65.4688C24.2953 64.6536 27.4696 63.5236 28.4683 63.2849C29.5097 63.0356 30.1043 63.0812 30.1043 63.0812C28.2213 61.6142 17.9336 65.9621 24.8793 67.2091C43.82 70.6057 59.4061 65.6793 54.493 63.2271L54.4937 63.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6445 47.2723C34.6445 47.2723 26.0201 49.5391 31.5905 50.363C33.9432 50.7113 38.6306 50.6311 42.9997 50.2256C46.5696 49.8941 50.1521 49.1853 50.1521 49.1853C50.1521 49.1853 48.8943 49.7822 47.9836 50.4698C39.2235 53.0186 22.3047 51.8316 27.1764 49.2257C31.2944 47.0218 34.6442 47.2723 34.6442 47.2723L34.6445 47.2723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1169 56.8387C59.0208 51.7213 54.9036 46.803 52.0299 47.4656C51.3272 47.6278 51.0119 47.7684 51.0119 47.7684C51.0119 47.7684 51.2737 47.3146 51.7722 47.1194C57.4573 44.9093 61.8285 53.64 49.939 57.0975C49.9389 57.0975 50.0757 56.9605 50.1169 56.8385L50.1169 56.8387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7495 18.3745C44.7495 18.3745 49.6795 23.8318 40.072 32.2211C32.3674 38.9534 38.3153 42.7907 40.0692 47.177C35.5715 42.688 32.2725 38.7357 34.4853 35.0583C37.7347 29.6604 46.7381 27.0425 44.7496 18.3745H44.7495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5197 70.7104C44.0644 71.3148 57.19 70.3741 57.5004 65.9006C57.5004 65.9006 56.9033 67.5964 50.4379 68.942C43.144 70.4611 34.1456 70.2843 28.8107 69.3098C28.8107 69.3098 29.9036 70.3106 35.5195 70.7104L35.5197 70.7104Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7726 56.3509C33.7726 56.3509 31.9602 57.518 35.0639 57.9117C38.8246 58.3867 40.7463 58.3183 44.8893 57.4519C44.8893 57.4519 45.9808 58.2073 47.5024 58.8615C38.2117 63.265 26.4758 58.6063 33.7723 56.3508L33.7726 56.3509Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6365 50.6034C32.6365 50.6034 30.6034 52.2687 33.7094 52.6239C37.7271 53.0827 40.8986 53.1203 46.3896 51.9512C46.3896 51.9512 47.1474 52.8027 48.3407 53.2681C37.1094 56.9024 24.6006 53.554 32.6359 50.6034L32.6365 50.6034Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.206 40.852C44.4964 43.7687 41.6054 46.3913 41.6054 46.3913C41.6054 46.3913 47.4177 43.0724 44.7489 38.9144C42.2555 35.0386 40.3439 33.1133 50.6931 26.473C50.6932 26.473 34.4471 30.9607 42.206 40.8518L42.206 40.852Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4937 60.6023C54.4937 60.6023 55.8354 61.8259 53.0159 62.7722C47.6546 64.5687 30.6972 65.1106 25.9872 62.8441C24.2953 62.0288 27.4696 60.8988 28.4683 60.6601C29.5097 60.4109 30.1043 60.4564 30.1043 60.4564C28.2213 58.9895 17.9336 63.3374 24.8793 64.5844C43.82 67.9809 59.4061 63.0545 54.493 60.6023L54.4937 60.6023Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6445 44.6475C34.6445 44.6475 26.0201 46.9144 31.5905 47.7382C33.9432 48.0865 38.6306 48.0064 42.9997 47.6008C46.5696 47.2694 50.1521 46.5605 50.1521 46.5605C50.1521 46.5605 48.8943 47.1575 47.9836 47.845C39.2235 50.3939 22.3047 49.2068 27.1764 46.601C31.2944 44.397 34.6442 44.6475 34.6442 44.6475L34.6445 44.6475Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1169 54.2139C59.0208 49.0966 54.9036 44.1783 52.0299 44.8408C51.3272 45.0031 51.0119 45.1436 51.0119 45.1436C51.0119 45.1436 51.2737 44.6899 51.7722 44.4946C57.4573 42.2845 61.8285 51.0152 49.939 54.4728C49.9389 54.4728 50.0757 54.3357 50.1169 54.2138L50.1169 54.2139Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7495 15.7498C44.7495 15.7498 49.6795 21.207 40.072 29.5963C32.3674 36.3286 38.3153 40.166 40.0692 44.5522C35.5715 40.0632 32.2725 36.111 34.4853 32.4336C37.7347 27.0357 46.7381 24.4177 44.7496 15.7498H44.7495Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5197 68.0857C44.0644 68.6901 57.19 67.7493 57.5004 63.2759C57.5004 63.2759 56.9033 64.9717 50.4379 66.3172C43.144 67.8364 34.1456 67.6595 28.8107 66.685C28.8107 66.685 29.9036 67.6858 35.5195 68.0856L35.5197 68.0857Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.06824 43.3125C5.05356 43.7518 5.00476 44.1818 5.00476 44.625C5.00476 64.9845 20.6148 81.375 40.0048 81.375C59.3948 81.375 75.0048 64.9845 75.0048 44.625C75.0048 44.1818 74.956 43.7518 74.9413 43.3125C74.2813 63.0551 58.9713 78.75 40.0038 78.75C21.0358 78.75 5.72629 63.0551 5.06629 43.3125H5.06824Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40 5.25C20.61 5.25 5 21.6405 5 42C5 42.4436 5.04875 42.8741 5.0635 43.3125C5.72275 23.5709 21.032 7.875 40.001 7.875C58.9685 7.875 74.2785 23.5709 74.9385 43.3125C74.951 42.8741 75.001 42.4436 75.001 42C75.001 21.6405 59.391 5.25 40.001 5.25H40Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.211ad2dc757f8b6de84edadbc2828c1f.svg";
export { ForwardRef as ReactComponent };